<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-pass-additional-purpose" class="control-label">{{ inputLabel }}</label>
    <input
      v-model="inputValue"
      :disabled="disabled"
      id="form-pass-additional-purpose"
      autocomplete="off"
      class="form-control"
      :maxlength="maxlength || -1"
      @input="emit"
      @change="emit"
      @blur="emit"
    />
    <p v-if="isMaxLength" style="color: #a94442;">
      Достигнута максимальная длина ввода!
    </p>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'PassAdditionalPurposeInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Основание'
    },

    inputName: {
      default: 'additional_purpose'
    },

    inputHint: {
      default: undefined
    },

    isContractFieldsDisplay: {
      default: false
    },

    maxlength: {
      default: undefined
    }
  },

  computed: {
    isMaxLength() {
      if (this.maxlength === undefined || this.maxlength < 0) {
        return false
      }

      return this.inputValue?.length >= this.maxlength
    }
  }
}
</script>
